/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CharityBalanceAdjustmentDto } from '../models/CharityBalanceAdjustmentDto';
import type { CharityBalanceResponseDto } from '../models/CharityBalanceResponseDto';
import type { CharityPaymentDto } from '../models/CharityPaymentDto';
import type { CharityPaymentIntentResponseDto } from '../models/CharityPaymentIntentResponseDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CharitiesPaymentService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create charity payment intent
     * @param idempotencyKey Unique key to prevent duplicate requests (UUID recommended)
     * @param requestBody Data for creating a charity payment intent
     * @returns CharityPaymentIntentResponseDto The charity payment intent has been successfully created.
     * @throws ApiError
     */
    public charitiesPaymentControllerCreatePaymentIntent(
        idempotencyKey: string,
        requestBody: CharityPaymentDto,
    ): Observable<CharityPaymentIntentResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/charities/payment/intent',
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data or missing Idempotency-Key header.`,
                403: `Access denied.`,
                409: `Request with this idempotency key is already being processed.`,
            },
        });
    }
    /**
     * Get charity payment intent by ID
     * @param id The UUID of the payment intent
     * @returns CharityPaymentIntentResponseDto The charity payment intent details.
     * @throws ApiError
     */
    public charitiesPaymentControllerGetPaymentIntent(
        id: string,
    ): Observable<CharityPaymentIntentResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/payment/intent/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied.`,
                404: `Payment intent not found.`,
            },
        });
    }
    /**
     * Get charity payment intents by charity ID
     * @param charityId The UUID of the charity
     * @returns CharityPaymentIntentResponseDto List of charity payment intents.
     * @throws ApiError
     */
    public charitiesPaymentControllerGetPaymentIntentsByCharityId(
        charityId: string,
    ): Observable<Array<CharityPaymentIntentResponseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/payment/charity/{charityId}/intents',
            path: {
                'charityId': charityId,
            },
            errors: {
                403: `Access denied.`,
            },
        });
    }
    /**
     * Update charity payment intent status
     * @param id The UUID of the payment intent
     * @param status The new payment status
     * @returns CharityPaymentIntentResponseDto The charity payment intent status has been successfully updated.
     * @throws ApiError
     */
    public charitiesPaymentControllerUpdatePaymentIntentStatus(
        id: string,
        status: 'PENDING' | 'POSTED' | 'CANCELED',
    ): Observable<CharityPaymentIntentResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/charities/payment/intent/{id}/status/{status}',
            path: {
                'id': id,
                'status': status,
            },
            errors: {
                403: `Access denied.`,
                404: `Payment intent not found.`,
            },
        });
    }
    /**
     * Verify payment session status (for frontend redirect handling)
     * @param sessionId The Stripe session ID to verify
     * @returns any Payment session verification result.
     * @throws ApiError
     */
    public charitiesPaymentControllerVerifyPaymentSession(
        sessionId: string,
    ): Observable<{
        session_id?: string;
        payment_status?: string;
        payment_intent_id?: string;
        verified?: boolean;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/charities/payment/verify-session/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            errors: {
                404: `Session not found.`,
            },
        });
    }
    /**
     * Adjust charity account balance (add or deduct funds)
     * @param charityId The UUID of the charity
     * @param idempotencyKey Unique key to prevent duplicate requests (UUID recommended)
     * @param requestBody Data for adjusting charity account balance
     * @returns CharityBalanceResponseDto The charity balance has been successfully adjusted.
     * @throws ApiError
     */
    public charitiesPaymentControllerAdjustCharityBalance(
        charityId: string,
        idempotencyKey: string,
        requestBody: CharityBalanceAdjustmentDto,
    ): Observable<CharityBalanceResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/charities/payment/charity/{charityId}/balance/adjust',
            path: {
                'charityId': charityId,
            },
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data, insufficient balance, or missing Idempotency-Key header.`,
                403: `Access denied. Only Super Admin and Admin can adjust balances.`,
                409: `Request with this idempotency key is already being processed.`,
            },
        });
    }
}
